import PageMain from '../../components/Navigation/PageMain/PageMain';
import IntegrationsSettings from '../../components/Settings/Integrations/IntegrationsSettings';

export default function IntegrationsSettingsPage() {
    return (
        <PageMain pageTitle="Integrations Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <IntegrationsSettings />
                </div>
            </div>
        </PageMain>
    );
}
